export default class Restriction {
    id: number;
    contractLookupId?: number;
    no?: number;
    category: string;
    note: string;
    createdByUserId?: number;
    createdDate?: Date;
    modifiedByUserId?: number;
    modifiedDate?: Date;

    // not mapped
    costType: string;
}


// WEBPACK FOOTER //
// ./src/models/leasehold/Restriction.ts